import { render, staticRenderFns } from "./CDistributor.vue?vue&type=template&id=17e3b887"
import script from "./CDistributor.vue?vue&type=script&lang=js"
export * from "./CDistributor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports